export enum AbortReason {
  Canceled,
  Retry,
  TimeOut
}
